// ====================================================================
// CLIENT FOLLOW-UP CRM - LOGIN VIEW
// ====================================================================

import { login, demoLogin } from '../auth.js';
import { showToast } from '../ui.js';

export function renderLoginView(container) {
  container.innerHTML = `
    <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background-color: var(--bg-app); padding: 1.5rem;">
      <div style="width: 100%; max-width: 420px; background-color: var(--bg-card); border-radius: var(--radius-lg); border: 1px solid var(--border-color); box-shadow: var(--shadow-lg); padding: 2.5rem 2rem;">
        <div style="text-align: center; margin-bottom: 2rem;">
          <div style="width: 48px; height: 48px; background: linear-gradient(135deg, #6366f1, #4f46e5); border-radius: var(--radius-md); display: inline-flex; align-items: center; justify-content: center; color: white; font-weight: 800; font-size: 1.5rem; margin-bottom: 1rem; box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);">
            C
          </div>
          <h1 style="font-size: 1.5rem; font-weight: 700; color: var(--text-primary);">Client Follow-up CRM</h1>
          <p style="font-size: 0.875rem; color: var(--text-muted); margin-top: 0.25rem;">Sign in to manage client follow-ups</p>
        </div>

        <form id="login-form">
          <div class="form-group">
            <label class="form-label" for="login-email">Email Address <span class="required">*</span></label>
            <input type="email" id="login-email" class="form-control" placeholder="name@company.com" required value="admin@crm.com">
          </div>

          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label" for="login-password">Password <span class="required">*</span></label>
            <input type="password" id="login-password" class="form-control" placeholder="••••••••" required value="password123">
          </div>

          <button type="submit" class="btn btn-primary btn-lg" style="width: 100%; margin-bottom: 1.5rem;">
            Sign In
          </button>
        </form>

        <div style="border-top: 1px solid var(--border-color); padding-top: 1.25rem; text-align: center;">
          <p style="font-size: 0.8125rem; color: var(--text-muted); margin-bottom: 0.75rem; font-weight: 600;">DEMO QUICK ACCESS</p>
          <div style="display: flex; gap: 0.75rem;">
            <button id="btn-demo-admin" class="btn btn-secondary btn-sm" style="flex: 1;">
              Admin Role
            </button>
            <button id="btn-demo-staff" class="btn btn-secondary btn-sm" style="flex: 1;">
              Staff Role
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  // Attach login event handlers
  document.getElementById('login-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = document.getElementById('login-email').value;
    const password = document.getElementById('login-password').value;

    try {
      const user = await login(email, password);
      showToast(`Welcome back, ${user.name}!`, 'success');
      window.location.hash = user.role === 'admin' ? '#dashboard' : '#staff-dashboard';
    } catch (err) {
      showToast(err.message || 'Login failed', 'error');
    }
  });

  document.getElementById('btn-demo-admin').addEventListener('click', () => {
    const user = demoLogin('admin');
    showToast('Logged in as Admin (Demo)', 'success');
    window.location.hash = '#dashboard';
  });

  document.getElementById('btn-demo-staff').addEventListener('click', () => {
    const user = demoLogin('staff');
    showToast('Logged in as Staff (Demo)', 'success');
    window.location.hash = '#staff-dashboard';
  });
}
